export const ItemTypes = {
  ELEMENT: 'element',
  ROW: 'row'
};



// WEBPACK FOOTER //
// ./app/header-builder/constants.js